import { useLocation } from "react-router-dom";
import useDesignerMode, { setDesignerMode, useDesignerTriggers } from "@/hooks/useDesignerMode";

// Global designer-mode wiring plus the corner tag (click to turn off).
export default function DesignerTag() {
  const { search } = useLocation();
  useDesignerTriggers(search);
  const on = useDesignerMode();
  if (!on) return null;
  return (
    <button
      type="button"
      data-testid="designer-mode-tag"
      onClick={() => setDesignerMode(false)}
      title="Turn designer mode off"
      className="fixed bottom-2 left-2 z-[1000] px-2 py-1 text-[11px] cursor-pointer"
      style={{ background: "var(--card)", color: "var(--ink-3)", border: "1px solid var(--line)", borderRadius: "var(--radius)", fontFamily: "var(--font-ui)" }}
    >
      Designer mode
    </button>
  );
}
